"use strict";
/*
 * Copyright (C) 2017-2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoiRendererFactory = void 0;
const PoiRenderer_1 = require("./PoiRenderer");
class PoiRendererFactory {
    /**
     * Creates an instance of poi renderer factory.
     * @param m_mapView -
     */
    constructor(m_mapView) {
        this.m_mapView = m_mapView;
    }
    /**
     * Creates poi renderer
     * @param textCanvas -
     * @returns
     */
    createPoiRenderer(textCanvas) {
        return new PoiRenderer_1.PoiRenderer(this.m_mapView, textCanvas);
    }
}
exports.PoiRendererFactory = PoiRendererFactory;
//# sourceMappingURL=PoiRendererFactory.js.map